import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { Row, Col, Input, Checkbox } from 'antd';

import Form, { FormItem } from '../../../components/Form';

interface IVouchersFormProps extends RouteComponentProps<{ eshop: string }> {
  onSave: (data: any) => void;
  onCancel: () => void;
}

interface IVouchersFormState {
  data: any;
}

class VouchersForm extends React.Component<IVouchersFormProps, IVouchersFormState> {

  public constructor(props: IVouchersFormProps) {
    super(props);

    this.state = {
      data: {
        active: true,
      },
    };

    this.onChange = this.onChange.bind(this);
    this.save = this.save.bind(this);
  }

  public render() {
    const { data } = this.state;

    return (
      <div>
        <Form
          buttonSaveCaption={'Generate vouchers'}
          onSubmit={this.save}
          onCancel={this.props.onCancel}
        >
          <Row>
            <Col md={24} lg={11}>
              <FormItem label={'Vouchers count'} required={true}>
                <Input
                  name={'count'}
                  autoFocus={true}
                  placeholder="Vouchers count"
                  value={data.count || ''}
                  required={true}
                  onChange={this.onChange}
                />
              </FormItem>
              <FormItem label={'Usage limit'} required={true}>
                <Input
                  name={'usageLimit'}
                  placeholder="Usage limit"
                  value={data.usageLimit}
                  required={true}
                  onChange={this.onChange}
                />
              </FormItem>
              <FormItem label={'Valid from'}>
                <Input
                  type={'date'}
                  name={'validFrom'}
                  placeholder="Valid from"
                  value={data.validFrom}
                  onChange={this.onChange}
                />
              </FormItem>
              <FormItem label={'Valid to'}>
                <Input
                  type={'date'}
                  name={'validTo'}
                  placeholder="Valid to"
                  value={data.validTo}
                  onChange={this.onChange}
                />
              </FormItem>
              <FormItem>
                <Checkbox
                  name={'active'}
                  checked={!!data.active}
                  onChange={this.onChange}
                >
                  Active
                </Checkbox>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
    );
  }

  private onChange(e: any, language?: string) {
    const { name, value, checked } = e.target;

    const inputValue = (value !== undefined ? value : checked);

    const newValue = (language
      ? { [name]: { ...this.state.data[name], [language]: inputValue } }
      : { [name]: inputValue });
    this.setState({
      data: { ...this.state.data, ...newValue }
    });
  }

  private async save() {
    this.props.onSave({...this.state.data});
  }
}

export default withRouter(VouchersForm);



// WEBPACK FOOTER //
// ./src/scenes/VouchersGenerateRandom/VouchersForm/VouchersForm.tsx